{
  "dismiss": "取消"
}